module.exports = __webpack_public_path__ + "static/logo-b59c5f1200fa745b067cc50fe8266dc0.png";